// extracted by mini-css-extract-plugin
export default {"melodyVideo":"UI-z","isFullWidth":"VI-z","landingPageVideo":"WI-z","play":"XI-z","iframeVideo":"YI-z","playHidden":"ZI-z","fullwidth":"_I-z"};